import { Stack, Typography } from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

interface Props {
	validationType?: string;
	mode?: "view" | "review";
}

/**
 * Polished fallback shown when the validationType isn't yet wired into a
 * specialized renderer (ATTENDANCE, CAPTURE_VIDEO, future types). Keeps the
 * modal layout intact instead of leaving a bare paragraph.
 */
export const GenericPlaceholder = ({ validationType }: Props) => (
	<Stack
		alignItems="center"
		spacing={1}
		sx={{
			p: 4,
			bgcolor: "action.hover",
			borderRadius: 1,
			color: "text.secondary",
		}}
	>
		<HelpOutlineIcon fontSize="large" />
		<Typography variant="body2" align="center">
			Review for <strong>{validationType ?? "this event type"}</strong> is not
			yet implemented.
		</Typography>
		<Typography variant="caption" align="center">
			Submitted data is preserved and will render once support is added.
		</Typography>
	</Stack>
);
